const CONSENT_STORAGE_KEY = "engram_cookie_consent";
const CONSENT_VERSION = 1;

const ENABLE_ANALYTICS = process.env.VUE_APP_ENABLE_ANALYTICS === "true";
const SHOW_PRIVACY_BANNER = process.env.VUE_APP_SHOW_PRIVACY_BANNER !== "false";

function isClient() {
  return typeof window !== "undefined";
}

function normalizeConsent(input = {}) {
  return {
    analytics: ENABLE_ANALYTICS && Boolean(input.analytics),
    timestamp: Date.now(),
    version: CONSENT_VERSION
  };
}

function readStoredConsent() {
  if (!isClient()) {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") {
      return null;
    }

    return {
      analytics: Boolean(parsed.analytics),
      timestamp: Number(parsed.timestamp) || Date.now(),
      version: Number(parsed.version) || CONSENT_VERSION
    };
  } catch (error) {
    return null;
  }
}

function emitConsentChange(consent) {
  if (!isClient()) {
    return;
  }

  window.dispatchEvent(
    new CustomEvent("engram:consent-updated", {
      detail: consent
    })
  );
}

export function getConsent() {
  return readStoredConsent();
}

export function setConsent(nextConsent) {
  if (!isClient()) {
    return normalizeConsent(nextConsent);
  }

  const normalized = normalizeConsent(nextConsent);

  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(normalized));
  } catch (error) {
    // Ignore write failures to avoid interrupting the UX.
  }

  emitConsentChange(normalized);
  return normalized;
}

export function hasAnalyticsConsent() {
  if (!ENABLE_ANALYTICS) {
    return false;
  }

  const consent = getConsent();

  // Opt-out model: collect analytics by default until a user explicitly denies.
  if (!consent) {
    return true;
  }

  return Boolean(consent.analytics);
}

export function clearConsent() {
  if (!isClient()) {
    return;
  }

  try {
    window.localStorage.removeItem(CONSENT_STORAGE_KEY);
  } catch (error) {
    // Ignore clear failures to avoid interrupting the UX.
  }

  emitConsentChange(null);
}

export function shouldShowBanner() {
  return Boolean(SHOW_PRIVACY_BANNER && !getConsent());
}

export function isAnalyticsFeatureEnabled() {
  return ENABLE_ANALYTICS;
}

export function isPrivacyBannerEnabled() {
  return SHOW_PRIVACY_BANNER;
}
